import "core-js/modules/es.string.link.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

var BreadCrumbItem = function BreadCrumbItem(_ref) {
  var link = _ref.link,
      name = _ref.name,
      _ref$insideRouter = _ref.insideRouter,
      insideRouter = _ref$insideRouter === void 0 ? true : _ref$insideRouter;
  return name !== undefined ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-angle-left main-txt"
  }), link !== undefined ? insideRouter ? /*#__PURE__*/React.createElement(Link, {
    to: link,
    className: "main-txt main-txt-hover"
  }, name) : /*#__PURE__*/React.createElement("a", {
    href: link,
    className: "main-txt main-txt-hover"
  }, name) : /*#__PURE__*/React.createElement("span", null, name)) : null;
};

BreadCrumbItem.propTypes = {
  name: PropTypes.string,
  link: PropTypes.string,
  insideRouter: PropTypes.bool
};
export default BreadCrumbItem;